import { render, staticRenderFns } from "./disclamer.vue?vue&type=template&id=0ecaff5f&"
import script from "./disclamer.vue?vue&type=script&lang=js&"
export * from "./disclamer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports